/**
 * 活动管理
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async saveFormDetail(result) {
    return request(api.market.ACT, METHOD.POST, result);  //保存表单
  },
  async getFormDetail(keyId) {
    return request(api.market.ACT + '/' + keyId, METHOD.GET);
  },
  async getMarketList(searchResult, actType) {
    return request(api.market.ACT + '?actType=' + actType, METHOD.GET, searchResult);
  },
  async deleteMarketItem(keyId) { // 删除 单个
    return request(api.market.ACT + "/deleteActivity?actId=" + keyId, METHOD.GET);
  },
  async changeStatus(result) {
    return request(api.market.ACT + '/updateStatus', METHOD.GET, result);
  },
  async getTagList(result) {
    return request(api.operate.TAGAll, METHOD.GET, result);
  },
  async getTemplateInfoByType(keyId) {
    return request(api.market.ACT + '/getTemplateInfoByType?actType=' + keyId, METHOD.GET);
  },
  async send(result) {
    return request(api.market.ACT + '/exchangePrizeStatus', METHOD.POST, result);
  },

}

export default {dataApi}
